import {
	BillingTotals,
	UserTransactionStatus,
	dateOrNull,
} from "../../../index";

type UserTransactionProps = {
	id: string;
	billedAt: Date | null;
	createdAt: Date | null;
	totals: BillingTotals;
	status: UserTransactionStatus;
	updatedAt: Date | null;
	subscriptionId: string;
};

class UserTransaction {
	id: string;
	billedAt: Date | null;
	createdAt: Date | null;
	totals: BillingTotals;
	status: UserTransactionStatus;
	updatedAt: Date | null;
	subscriptionId: string;

	constructor({
		id,
		billedAt,
		createdAt,
		totals,
		status,
		updatedAt,
		subscriptionId,
	}: UserTransactionProps) {
		this.id = id;
		this.billedAt = billedAt;
		this.createdAt = createdAt;
		this.totals = totals;
		this.status = status;
		this.updatedAt = updatedAt;
		this.subscriptionId = subscriptionId;
	}

	static fromFirestore(userSubscription: any) {
		const data = userSubscription.data();
		return new UserTransaction({
			id: userSubscription.id,
			billedAt: dateOrNull(data.billed_at),
			createdAt: dateOrNull(data.created_at),
			totals: BillingTotals.fromJson(data.details.totals),
			status: data.status,
			updatedAt: dateOrNull(data.updated_at),
			subscriptionId: data.subscription_id,
		});
	}

	static fromJson(data: any) {
		return new UserTransaction({
			id: data.id,
			billedAt: dateOrNull(data.billed_at),
			createdAt: dateOrNull(data.created_at),
			totals: BillingTotals.fromJson(data.totals || data.details?.totals || {}),
			status: data.status,
			updatedAt: dateOrNull(data.updated_at),
			subscriptionId: data.subscription_id,
		});
	}

	toJson() {
		return {
			id: this.id,
			billed_at: this.billedAt,
			created_at: this.createdAt,
			totals: this.totals.toJson(),
			status: this.status,
			updated_at: this.updatedAt,
			subscription_id: this.subscriptionId,
		};
	}
}

export { UserTransaction };
